import PropTypes from 'prop-types';
import React from 'react';
import style from './FormTextArea.module.css';

export const FormTextArea = ({ controlledValue, onChange, width, rows, color, backgroundColor, placeholder }) => {
  return (
    <textarea
      style={{ width, color, backgroundColor, borderColor: color }}
      rows={rows}
      spellCheck={false}
      placeholder={placeholder}
      value={controlledValue}
      onChange={({ target }) => onChange(target.value)}
      className={style.textarea}
    />
  );
};

FormTextArea.propTypes = {
  controlledValue: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  width: PropTypes.string,
  rows: PropTypes.number,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  placeholder: PropTypes.string,
};
